<script>
import {
  Line
} from 'vue-chartjs'

export default {
  extends: Line,
  props: ['data', 'options'],
  watch: {
    data(val) {
      this.renderChart(this.data, this.opt);
    }
  },
  computed: {
    opt() {
      if (this.options.legend && this.options.legend.display) {
        this.options.legend.onHover = function(e, legendItem) {
          e.target.style.cursor = 'pointer';
        };
        this.options.legend.onLeave = function(e, legendItem) {
          e.target.style.cursor = 'default';
        };
      }
      return this.options;
    }
  },
  mounted() {
    this.renderChart(this.data, this.opt);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/Line.vue